import { NewsForm } from './NewsForm'

export const Create = () => {
  return <NewsForm />
}
